<template>
  <v-row no-gutters>
    <v-col class="px-5 py-6" cols="12">
      <v-row no-gutters class="align-center">
        <v-col cols="6">
          <italic-subheader translation-path="dialog.attachments.assignFiles"> </italic-subheader>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="pa-0 mr-2">
          <v-text-field
            outlined
            dense
            append-icon="mdi-magnify"
            :placeholder="$i18n.t('default.find')"
            clearable
            hide-details
            v-model="search"
            class="align-center justify-center"
          />
        </v-col>
        <v-col cols="1">
          <v-btn @click="changeListView" max-width="35px" outlined style="outline-color: #5f6368">
            <v-icon size="16px"> {{ icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <keep-alive>
            <component
              :is="getTabName"
              :attachments="searchedItems"
              @input="setSelected"
              :assigned="selected"
            ></component>
          </keep-alive>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ItalicSubheader from '@/components/ItalicSubheader';
import AttachmentTileGrid from '@/components/AttachmentTileGrid';
import AttachmentListView from '@/components/AttachmentListView';

export default {
  name: 'AssignAttachmentTab',
  components: { AttachmentListView, AttachmentTileGrid, ItalicSubheader },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    search: '',
    gridView: false,
  }),
  computed: {
    icon() {
      if (this.gridView) {
        return 'mdi-view-grid';
      } else {
        return 'mdi-menu';
      }
    },
    searchedItems() {
      if (!this.search) {
        return this.attachments;
      } else {
        return this.attachments.filter(a => a.name.includes(this.search));
      }
    },
    getTabName() {
      if (this.gridView) {
        return 'AttachmentListView';
      } else {
        return 'AttachmentTileGrid';
      }
    },
  },
  methods: {
    changeListView() {
      this.setSelected([]);
      this.gridView = !this.gridView;
    },
    setSelected(data) {
      this.$emit('selectAttachments', data);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__icon .v-icon {
  font-size: 15px;
}
::v-deep .v-text-field__slot input {
  font-size: 12px;
}
::v-deep .v-input__control .v-input__slot {
  min-height: 20px !important;
  max-height: 25px !important;
  padding-right: 0 !important;
}
::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}
::v-deep .v-btn--outlined {
  border: thin solid rgba(0, 0, 0, 0.1) !important;
  padding: 0 0 !important;
  min-width: 45px !important;
}
</style>
